import { createContext } from 'react';
import { ConfigureType } from '../../../apis';

const ManageMainContext = createContext<ConfigureType[]>([]);

export default ManageMainContext;
